import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class TikTok implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_TIKTOK;
  label: string = 'TikTok';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = true;

  getClientIdRegexp(): RegExp {
    return /^[A-Z0-9]{20}$/;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
